import { useState } from "react";

import iconAuto from "../../assets/images/72-auto.svg";
import iconKeyboard from "../../assets/images/72-keyboard-step.svg";
import ms1 from "../../assets/images/72-ms-1.svg";
import ms2 from "../../assets/images/72-ms-2.svg";
import ms3 from "../../assets/images/72-ms-3.svg";
import ms4 from "../../assets/images/72-ms-4.svg";
import ms5 from "../../assets/images/72-ms-5.svg";
import ms6 from "../../assets/images/72-ms-6.svg";
import ms7 from "../../assets/images/72-ms-7.svg";
import ms8 from "../../assets/images/72-ms-8.svg";
import ms9 from "../../assets/images/72-ms-9.svg";
import iconMouse from "../../assets/images/select-item.svg";

const MKSteps = () => {
  const [mainItem, setMainItem] = useState(null);
  const [activeItem, setActiveItem] = useState(-1);

  const mouseItems = [
    {
      id: 1,
      name: "ms1",
      src: ms1,
      shortKey: "L",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 2,
      name: "ms2",
      src: ms2,
      shortKey: "A",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 3,
      name: "ms3",
      src: ms3,
      shortKey: "W",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 4,
      name: "ms4",
      src: ms4,
      shortKey: "P",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 5,
      name: "ms5",
      src: ms5,
      shortKey: "C",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 6,
      name: "ms6",
      src: ms6,
      shortKey: "S",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 7,
      name: "ms7",
      src: ms7,
      shortKey: "R",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 8,
      name: "ms8",
      src: ms8,
      shortKey: "M",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
    {
      id: 9,
      name: "ms9",
      src: ms9,
      shortKey: "T",
      title: "ADD MOUSE CLICK TO STEP",
      description: "Lorem more about this and mouse click to step",
    },
  ];

  return (
    <>
      <div className="mouse-keyboard-steps">
        <ul>
          <li id="step-mouse" onClick={() => setMainItem("mouse")} className={mainItem === "mouse" ? "active" : null}>
            <img alt="" src={iconMouse} className="btn-32 btn-mouse-step" />
          </li>
          <li id="step-keyboard" onClick={() => setMainItem("keyboard")} className={mainItem === "keyboard" ? "active" : null}>
            <img alt="" src={iconKeyboard} className="btn-32 btn-keyboard-step" />
          </li>
          <li id="step-auto" onClick={() => setMainItem("keyboard")} className={mainItem === "auto" ? "active" : null}>
            <img alt="" src={iconAuto} className="btn-32 btn-auto" />
          </li>
        </ul>
      </div>

      {/* mouse steps */}
      {mainItem === "mouse" && (
        <div className="mouse-keyboard-step2">
          {mouseItems.map((i, index) => (
            <img
              alt=""
              src={`${i.src}`}
              className={`btn-32 mouse-items btn-${i.name}`}
              onMouseOver={() => setActiveItem(index)}
              onMouseOut={() => setActiveItem(-1)}
            />
          ))}
        </div>
      )}

      {/* mouse steps description */}
      {activeItem >= 0 && (
        <div className="mouse-keyboard-description">
          <div className="mouse-keyboard-description-img">
            <img alt="" src={mouseItems[activeItem].src} width={65} />
          </div>
          <div className="mouse-keyboard-description-content">
            <div className="font-18 bold">
              {mouseItems[activeItem].title} - ITEM {mouseItems[activeItem].id}{" "}
            </div>
            <div className="short-key m-t-10 m-b-10">{mouseItems[activeItem].shortKey}</div>
            <span>{mouseItems[activeItem].description}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default MKSteps;
